<section>
    <h1 class="header">{{ buildHeader() }}</h1>
    <div class="progress-block">
        <h2 class="progress-header">{{ pageData.header }}</h2>
        <div class="shadow-circle">
            <div class="progress-circle"></div>
            <div class="content-holder">
                <div *ngIf="(!user.account.isSegmentFive && !user.account.isSegmentSix && !isCbmGemini) && !isUnlimited">
                    <div class="data-content">
                        <span class="value">{{ eligiblePlanDetails.sharedDataGB }}</span>
                        <span class="unit">{{ pageData.dataUnit }}</span>
                    </div>
                    <div class="ineligible-inuse" *ngIf="eligiblePlanDetails.inUseOnAccount; else dataRate">
                        <xm-media-image size="auto" class="checkmark-icon" [imageOptions]="checkmarkIcon">
                        </xm-media-image>
                        <span class="icon-subhead">{{ pageData.inUse }}</span>
                    </div>
                    <ng-template #dataRate>
                        <div class="data-rate">${{ pricePerUnit }}/{{ selectedPlanData.priceUnit }}</div>
                    </ng-template>
                </div>
                <div *ngIf="(!user.account.isSegmentFive && !user.account.isSegmentSix && !isCbmGemini) && isUnlimited">
                    <xm-media-image class="logo" [imageOptions]="iconOption" size="auto"></xm-media-image>
                    <div *ngIf="(!isCbmUserSegmentFiveTabletUnlimited); else tabletUnlimitedSeg5" class="plan-title">{{ selectedPlanData.planName }}</div>
                    <ng-template #tabletUnlimitedSeg5>
                        <div class="plan-title-seg5-tabletunlimited">{{ selectedPlanData.planName }}</div>
                    </ng-template>
                    <div class="data-rate">${{ pricePerUnit }}/{{ selectedPlanData.priceUnit }}</div>
                </div>
                <div *ngIf="(user.account.isSegmentFive || user.account.isSegmentSix || isCbmGemini)">
                    <xm-media-image class="logo" [imageOptions]="iconOption" size="auto"></xm-media-image>
                    <div class="plan-title">{{ selectedPlanData.planName }}</div>
                    <div *ngIf="(user.account.isSegmentFive || user.account.isSegmentSix || isCbmGemini)" class="data-rate">{{ pricePerUnit }}</div>
                </div>
            </div>
        </div>
        <p class="description" *ngIf="subhead">{{ subhead }}</p>
    </div>
</section>
